import React from "react";
import {
  Box,
  Chip,
  Divider,
  Typography,
} from "@mui/material";
import {
  DERIVED_PARAMETER_CHANGE_SUMMARY,
  DERIVED_PARAMETER_CHANGE_TYPE_LABELS,
} from "../../../constants/investigationAnalysisReview";

const getChangeTypeLabel = (changeType) =>
  DERIVED_PARAMETER_CHANGE_TYPE_LABELS[changeType] ||
  String(changeType || "Changed")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());

const getChangeTypeColor = (changeType) => {
  if (changeType === "added") return "success";
  if (changeType === "removed") return "error";
  return "warning";
};

const DerivedParameterChanges = ({ changes }) => {
  if (!changes?.has_changes) return null;

  const summary = changes.summary || {};
  const items = changes.items || [];

  return (
    <>
      <Typography
        id="derived-parameter-changes-title"
        fontSize={14}
        fontWeight={700}
        mt={2}
        mb={0.5}
      >
        Derived Parameter Changes
      </Typography>
      <Box
        component="section"
        aria-labelledby="derived-parameter-changes-title"
        sx={{ border: "1px solid #D0D5DD", borderRadius: 1, p: 1.5 }}
      >
        <Typography fontSize={14} mb={1}>
          The latest approved template contains changes to Derived Parameters.
          Review these changes before copying the batch.
        </Typography>

        <Box display="flex" flexWrap="wrap" gap={1} mb={1.5}>
          {DERIVED_PARAMETER_CHANGE_SUMMARY.map(({ key, label, color }) => (
            <Chip
              key={key}
              size="small"
              color={color}
              variant="outlined"
              label={`${label}: ${summary[key] ?? 0}`}
            />
          ))}
        </Box>

        {items.map((item, index) => (
          <Box key={item.parameter_id || `${item.parameter_name}-${index}`}>
            {index > 0 && <Divider sx={{ my: 1.5 }} />}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
              gap={1}
            >
              <Typography fontSize={14} fontWeight={700}>
                {item.parameter_name || "Unnamed Parameter"}
              </Typography>
              <Chip
                size="small"
                color={getChangeTypeColor(item.change_type)}
                variant="outlined"
                label={getChangeTypeLabel(item.change_type)}
              />
            </Box>

            {item.change_details && (
              <Typography color="text.secondary" fontSize={13} mt={0.5}>
                {item.change_details}
              </Typography>
            )}

          </Box>
        ))}
      </Box>
    </>
  );
};

export default DerivedParameterChanges;
